import type { ForHireSummaryConfig } from "../types/forHireSummaryTypes.ts"

export const ForHireFetchers: ForHireSummaryConfig = {
  gaugeThresholds: [952, 1190, 1428, 1570],
}
